
// config.development.ts
export default {
    baseUrl: '',
    apiKey: '',
    debugMode: false,
};